module.exports = __webpack_public_path__ + "static/media/3.17aaf2f5.png";